import { useState, useEffect, useRef } from 'react';
import { Input, Typography, Flex, Alert } from 'antd';
import { useNavigate, useLocation } from "react-router-dom";
import CustomButton from '../../components/CustomButton/Button';
import AuthCardLayout from '../../components/Auth/AuthCardLayout';
import { validateOtp, sendOtp, clearAuthError } from "../../redux/slices/AuthSlice";
import { useDispatch, useSelector } from "react-redux";
import { BTN_TXT, DESC_TXT, TITLE_TXT } from '../../constants/constants';

const { Text } = Typography;

const numberOfDigits = 6;

const Otp = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { email, messageId } = location.state;
    const [otp, setOtp] = useState(new Array(numberOfDigits).fill(""));
    const [seconds, setSeconds] = useState(60);
    const [isResendDisabled, setIsResendDisabled] = useState(true);
    const { loading, error } = useSelector((state) => state.auth);
    const otpBoxReference = useRef([]);

    const isOtpFilled = otp.every(digit => digit !== "");

    useEffect(() => {
        if (seconds > 0) {
            const timerId = setTimeout(() => setSeconds(seconds - 1), 1000);
            return () => clearTimeout(timerId);
        } else {
            setIsResendDisabled(false);
        }
    }, [seconds]);

    useEffect(() => {
        return () => {
            dispatch(clearAuthError());
        };
    }, [dispatch]);

    const handleResendOtp = async () => {
        setSeconds(60);
        setIsResendDisabled(true);

        dispatch(sendOtp(email))
    };

    const handleChange = (value, index) => {
        let newArr = [...otp];
        newArr[index] = value;
        setOtp(newArr);

        if (value && index < numberOfDigits - 1) {
            otpBoxReference.current[index + 1].focus();
        }
    };

    const handleBackspaceAndEnter = (e, index) => {
        if (e.key === "Backspace" && !e.target.value && index > 0) {
            otpBoxReference.current[index - 1].focus();
        }
        if (e.key === "Enter" && e.target.value && index < numberOfDigits - 1) {
            otpBoxReference.current[index + 1].focus();
        }
    };

    const handleSubmit = async () => {
        const otpString = otp.join("");
        const payload = { email: email, otp: otpString, messageId: messageId }
        const res = await dispatch(validateOtp(payload))
        if (res.payload.statusCode === 200) {
            const reset_token = res.payload.response?.reset_token;
            navigate('/reset-password', { state: { email: email, reset_token } })
        }
    };

    return (
        <AuthCardLayout
            title={TITLE_TXT.OTP_TITLE}
            subtitle={
                <Text style={{ fontSize: 14 }}>
                    {`Check ${email} for a verification code.`}
                    <span style={{ color: "#294DD8", fontWeight: 600, cursor: "pointer", fontSize: 14 }} onClick={() => navigate("/forgot-password")}>{BTN_TXT.CHANGE}</span>
                </Text>
            }
        >
            <Flex align='center' justify='space-between' style={{ marginTop: 40, width: "100%" }}>
                {otp.map((digit, index) => (
                    <Input
                        key={index}
                        value={digit}
                        onChange={(e) => handleChange(e.target.value, index)}
                        onKeyUp={(e) => handleBackspaceAndEnter(e, index)}
                        ref={(reference) => (otpBoxReference.current[index] = reference)}
                        className='otp-input'
                        maxLength={1}
                    />
                ))}
            </Flex>
            <CustomButton
                type="text"
                style={{ marginTop: 20, color: isResendDisabled ? "#ccc" : "#294DD8", fontWeight: 600, padding: 0 }}
                onClick={handleResendOtp}
                disabled={isResendDisabled}
            >
                {BTN_TXT.RESEND_OTP}
            </CustomButton>
            <Text style={{ color: "#40566D", marginTop: 20, fontSize: 12 }}>{DESC_TXT.OTP_INFO_TEXT}</Text>
            {error && <Alert style={{ marginTop: 20 }} message={error} type="error" showIcon />}
            <CustomButton
                type="primary"
                block
                onClick={handleSubmit}
                disabled={!isOtpFilled}
                loading={loading}
                style={{ marginTop: 30, marginBottom: 20, padding: 24 }}
            >
                {BTN_TXT.SUBMIT}
            </CustomButton>
            <div className='timer-container'>
                {isResendDisabled && (
                    <Text style={{ color: "#40566D", marginBottom: 20 }}>
                        Resend in {seconds} {seconds === 1 ? "second" : "seconds"}
                    </Text>
                )}
            </div>
        </AuthCardLayout>
    );
};

export default Otp;
